import appConfig from '@/features/app/constants/app-config';
import { Button } from '@thisisdmg/tirecloud-patterns';
import { Divider, Grid } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import CookieConsentModal from '../consent-modal';
import useReportBugButton from '../../../sentry/components/report-bug-button';

function Footer() {
  const { t } = useTranslation();
  const [isConsentModalOpen, setIsConsentModalOpen] = useState(
    localStorage.getItem(appConfig.cookieConsentKey) === null
  );
  const breakpoints = Grid.useBreakpoint();
  const { pathname } = useLocation();

  useEffect(() => {
    const updateCookieConsent = () => {
      setIsConsentModalOpen(localStorage.getItem(appConfig.cookieConsentKey) === null);
    };
    window.addEventListener('app:cookieConsentUpdated', updateCookieConsent);
    return () => {
      window.removeEventListener('app:cookieConsentUpdated', updateCookieConsent);
    };
  }, []);

  const reportBugButtonRef = useReportBugButton();

  return (
    <footer className="tw:h-[50px] tw:bg-black tw:text-white" id="main-footer">
      <CookieConsentModal
        isOpen={isConsentModalOpen && (breakpoints.xxl ?? false) && pathname !== '/privacy-policy'}
        onClose={() => {
          setIsConsentModalOpen(false);
        }}
      />
      <div className="tw:px-(--spacing-4) tw:h-full">
        <div className="tw:flex tw:justify-between tw:items-center tw:h-full tw:py-(--spacing-4)">
          <div className="version" dir="ltr">
            {import.meta.env.REACT_APP_VERSION_STRING.replace(
              `.${import.meta.env.REACT_APP_CORE_VERSION_STRING.replaceAll('+', '.')}`,
              ''
            )}
          </div>
          <div className="tw:flex tw:items-center tw:gap-x-2">
            <div className="tw:inline-flex tw:items-center tw:gap-x-(--spacing-2)">
              <Link
                to="/privacy-policy"
                className="tw:text-(--shade-400) tw:hover:text-(--shade-400) tw:hidden tw:md:block"
              >
                {t('component.footer.privacyPolicy')}
              </Link>
              <Divider type="vertical" className="tw:border-(--shade-400) tw:hidden tw:md:block" />
              <button
                ref={reportBugButtonRef}
                className="tw:text-(--shade-400) tw:hover:text-(--shade-400) tw:hidden tw:md:block"
              >
                {t('component.sentryFeedback.triggerLabel')}
              </button>
              <Button
                color="link"
                onClick={() => {
                  setIsConsentModalOpen(true);
                }}
                className="tw:text-(--shade-400)! tw:hover:text-(--shade-400)! tw:hidden tw:xl:inline-flex!"
              >
                {t('component.footer.cookieConsent')}
              </Button>
            </div>
            <Divider type="vertical" className="tw:border-(--shade-400) tw:hidden tw:md:block" />
            <div className="copyright">
              {t('component.footer.copyright', {
                year: new Date().getFullYear(),
              })}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
